import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';

export const BASE_URL = '/api/phones';
class PhonesRepository extends BaseRestRepository {
  public async canCompanySendTextMessages(): Promise<MagicDoor.Api.CompanyPhoneNumberStatusDto> {
    const response = await this.fetchWithAuth(BASE_URL + '/status');
    return this.getJsonResponse(response);
  }
  public async getAvailablePhoneNumbers(query: string): Promise<MagicDoor.Api.AvailablePhoneNumbersDto> {
    const response = await this.fetchWithAuth(urlWithQuery(BASE_URL + '/available', { startsWith: query }), {}, false);
    return this.getJsonResponse(response);
  }

  public async updateCompanyPhoneNumber(phoneNumber: string): Promise<unknown> {
    const response = await this.fetchWithAuth(BASE_URL + '/current', {
      method: 'PUT',
      body: JSON.stringify({ phoneNumber }),
    });
    return this.getJsonResponse(response);
  }
}

export const phonesRepository = new PhonesRepository();
